import '../../styles/step2d.css';
import '../../styles/platformTiles.css';

// Platform button + tile standard (Val, Oct 25 2026) - the Communications standard, as one import for every module.
// Buttons are the shared 3D face (.ia-btn3d): navy at rest, turquoise (.ia-btn3d--go) when selected or switched on.
// The pill shape (.ia-comms-pill) is the one Communications uses for its tabs, filters and actions.
// Tiles and cards use .ia-tile3d (platformTiles.css), the Settings tile look.

export const BTN = 'ia-btn3d ia-comms-pill';
export const BTN_ON = 'ia-btn3d ia-comms-pill ia-btn3d--go ia-comms-pill--on';

/** Class for a tab, filter or view pill: navy at rest, turquoise when selected. */
export function standardPillClass(selected) {
    return selected ? BTN_ON : BTN;
}

export const TILE = 'ia-tile3d';
export const TILE_INTERACTIVE = 'ia-tile3d ia-tile3d--interactive';
